const RemoveVscroll = () => {
    document.body.classList.add("no-vscroll");
};

export default RemoveVscroll;
